<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.2" />
    <path d="M15.7,15.7c-0.4,0.4-1,0.4-1.4,0L12,13.4l-2.3,2.3c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l2.3-2.3
    L8.3,9.7C7.9,9.3,7.9,8.7,8.3,8.3c0.4-0.4,1-0.4,1.4,0l2.3,2.3l2.3-2.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L13.4,12l2.3,2.3
    C16.1,14.7,16.1,15.3,15.7,15.7z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: "ErrorIcon"
}
</script> 